import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { analytics } from './utils/analytics'

// Meta Pixel
;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return
  n = f.fbq = function () {
    if ((n as any).callMethod) (n as any).callMethod.apply(n, arguments as any)
    else (n as any).queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  ;(n as any).push = n
  ;(n as any).loaded = true
  ;(n as any).version = '2.0'
  ;(n as any).queue = []
  t = b.createElement(e)
  ;(t as any).async = true
  ;(t as any).src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
;(window as any).fbq('init', '1234569501770792')
;(window as any).fbq('track', 'PageView')

// Enable XHR tracking for Google Analytics
analytics.enableXHRTracking()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
